import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import { HiOutlineUser, HiOutlinePhone } from 'react-icons/hi2';
import { IoClose } from 'react-icons/io5';
import { TbUsers } from 'react-icons/tb';
import CustomInput from '../../../Main/Components/Custom/CustomInput';

const WidgetGuestForm = ({ onGuestListUpdate, partySize = 1 }) => {
  const [guests, setGuests] = useState([]);

  const handleInputChange = (index, event) => {
    const values = [...guests];
    if (typeof event === 'string') {
      values[index].phoneNumber = event;
    } else {
      values[index][event.target.name] = event.target.value;
    }
    setGuests(values);
  };

  useEffect(() => {
    const validGuests = guests.filter(
      (g) => g.fullName?.trim() && g.phoneNumber?.trim(),
    );
    onGuestListUpdate?.(validGuests);
  }, [guests, onGuestListUpdate]);

  const handleAddGuest = () => {
    setGuests([...guests, { fullName: '', phoneNumber: '' }]);
  };

  const handleDeleteGuest = (index) => {
    const values = [...guests];
    values.splice(index, 1);
    setGuests(values);
  };

  const isAddDisabled = () => {
    if (guests.length === 0) return false;
    const last = guests[guests.length - 1];
    return !last.fullName || !last.phoneNumber;
  };

  const totalGuests =
    partySize + guests.filter((g) => g.fullName?.trim()).length;

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography
          sx={{ fontWeight: 800, fontSize: '13px', color: '#374151' }}
        >
          Additional Guests (Optional)
        </Typography>
        <Button
          disabled={isAddDisabled()}
          onClick={handleAddGuest}
          sx={{
            minWidth: 'auto',
            px: 0,
            fontWeight: 800,
            fontSize: '12px',
            textTransform: 'none',
          }}
        >
          + Add Guest
        </Button>
      </Box>

      {guests.map((guest, index) => (
        <Box
          key={index}
          sx={{
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            p: 2,
            mb: 1.5,
            bgcolor: '#fafafa',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1.5,
            }}
          >
            <Typography sx={{ fontWeight: 800, fontSize: '12px' }}>
              Guest Details
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleDeleteGuest(index)}
              sx={{ color: '#9ca3af' }}
            >
              <IoClose />
            </IconButton>
          </Box>
          <Box sx={{ position: 'relative', mb: 1.5 }}>
            <CustomInput
              fullWidth
              type="text"
              name="fullName"
              placeholder="Full name"
              value={guest.fullName}
              onChange={(e) => handleInputChange(index, e)}
              InputProps={{
                style: {
                  paddingLeft: 40,
                  borderRadius: '10px',
                  height: '48px',
                },
              }}
            />
          </Box>
          <Box sx={{ position: 'relative' }}>
            <CustomInput
              fullWidth
              type="phone_number"
              name="phoneNumber"
              placeholder="Phone Number"
              value={guest.phoneNumber}
              onChange={(value) => handleInputChange(index, value)}
              InputProps={{
                style: {
                  paddingLeft: 40,
                  borderRadius: '10px',
                  height: '48px',
                },
              }}
            />
          </Box>
        </Box>
      ))}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mt: 2,
          color: '#6b7280',
        }}
      >
        <TbUsers style={{ fontSize: 18 }} />
        <Typography sx={{ fontSize: '13px', fontWeight: 700 }}>
          Total Guests: {totalGuests}
        </Typography>
      </Box>
    </Box>
  );
};

export default WidgetGuestForm;
